import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule, Bell, Lock, User, CreditCard, Palette, Coins } from 'lucide-angular';
import { TranslatePipe } from '@ngx-translate/core';

import { SettingsProfileComponent } from './components/profile/profile.component';
import { SettingsNotificationsComponent } from './components/notifications/notifications.component';
import { SettingsSecurityComponent } from './components/security/security.component';
import { SettingsBillingComponent } from './components/billing/billing.component';
import { SettingsCurrencyComponent } from './components/currency/currency.component';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    LucideAngularModule,
    TranslatePipe,
    SettingsProfileComponent,
    SettingsNotificationsComponent,
    SettingsSecurityComponent,
    SettingsBillingComponent,
    SettingsCurrencyComponent,
  ],
  templateUrl: './settings.component.html',
})
export class SettingsComponent {
  // Icons
  Bell = Bell;
  Lock = Lock;
  User = User;
  CreditCard = CreditCard;
  Palette = Palette;
  Coins = Coins;

  // State
  activeTab = signal<
    'profile' | 'notifications' | 'security' | 'billing' | 'preferences' | 'currency'
  >('profile');

  setTab(tab: 'profile' | 'notifications' | 'security' | 'billing' | 'preferences' | 'currency') {
    this.activeTab.set(tab);
  }
}
